export enum DtwinOperationStatus {
  CANCELLED = "CANCELLED",
  CANCELLING = "CANCELLING",
  DELIVERED = "DELIVERED",
  DONE = "DONE",
  EXPIRED = "EXPIRED",
  FAILED = "FAILED",
  ON_HOLD = "ON_HOLD",
  PENDING = "PENDING",
  QUEUED = "QUEUED",
  RETRY = "RETRY",
  RUNNING = "RUNNING",
  SCHEDULED = "SCHEDULED",
}
